import type { PaginationQuery } from '../../../types/pagination';
import { appendPaginationQuery } from '../../../types/pagination';
import type { ApiClient } from '../client';
import type {
  CreateStudentPickupRequest,
  CreateStudentPickupResponse,
  ListPickupAuthorizationsResponse,
  ListRegisteredVehiclesResponse,
  ListStudentPickupsResponse,
  ListVehicleEntriesResponse,
  ListVisitorLogsResponse,
  Uuid,
} from '../types';

export function bindSecurity(client: ApiClient) {
  return {
async listVisitorLogs(params?: PaginationQuery) {
    const qs = new URLSearchParams();
    appendPaginationQuery(qs, params);
    const query = qs.toString();
    const path = query ? `/security/visitor-logs?${query}` : '/security/visitor-logs';
    return client.request<ListVisitorLogsResponse>(path);
  },

async createVisitorLog(body: Record<string, unknown>) {
    return client.request<{ visitor_log_id: Uuid; gate_pass_no: string }>('/security/visitor-logs', {
      method: 'POST',
      body: JSON.stringify(body),
    });
  },

async markVisitorExit(body: { visitor_log_id: string; out_time: string }) {
    return client.request<void>('/security/visitor-logs/exit', {
      method: 'POST',
      body: JSON.stringify(body),
    });
  },

async listPickupAuthorizations(params?: PaginationQuery & { phone?: string; student_id?: string }) {
    const qs = new URLSearchParams();
    appendPaginationQuery(qs, params);
    if (params?.phone?.trim()) qs.set('phone', params.phone.trim());
    if (params?.student_id?.trim()) qs.set('student_id', params.student_id.trim());
    const query = qs.toString();
    const path = query ? `/security/pickup-authorizations?${query}` : '/security/pickup-authorizations';
    return client.request<ListPickupAuthorizationsResponse>(path);
  },

async createPickupAuthorization(body: Record<string, unknown>) {
    return client.request<{ authorization_id: Uuid }>('/security/pickup-authorizations', {
      method: 'POST',
      body: JSON.stringify(body),
    });
  },

async listStudentPickups(params?: PaginationQuery) {
    const qs = new URLSearchParams();
    appendPaginationQuery(qs, params);
    const query = qs.toString();
    const path = query ? `/security/student-pickups?${query}` : '/security/student-pickups';
    return client.request<ListStudentPickupsResponse>(path);
  },

async createStudentPickup(body: CreateStudentPickupRequest) {
    return client.request<CreateStudentPickupResponse>('/security/student-pickups', {
      method: 'POST',
      body: JSON.stringify(body),
    });
  },

async listVehicleEntries(params?: PaginationQuery) {
    const qs = new URLSearchParams();
    appendPaginationQuery(qs, params);
    const query = qs.toString();
    const path = query ? `/security/vehicle-entries?${query}` : '/security/vehicle-entries';
    return client.request<ListVehicleEntriesResponse>(path);
  },

async createVehicleEntry(body: Record<string, unknown>) {
    return client.request<{ vehicle_entry_id: Uuid }>('/security/vehicle-entries', {
      method: 'POST',
      body: JSON.stringify(body),
    });
  },

async markVehicleExit(body: { vehicle_entry_id: string; exit_time: string }) {
    return client.request<void>('/security/vehicle-entries/exit', {
      method: 'POST',
      body: JSON.stringify(body),
    });
  },

async listRegisteredVehicles(params?: PaginationQuery & { status?: string }) {
    const qs = new URLSearchParams();
    appendPaginationQuery(qs, params);
    if (params?.status?.trim()) qs.set('status', params.status.trim());
    const query = qs.toString();
    const path = query ? `/security/registered-vehicles?${query}` : '/security/registered-vehicles';
    return client.request<ListRegisteredVehiclesResponse>(path);
  },

async createRegisteredVehicle(body: Record<string, unknown>) {
    return client.request<{ registered_vehicle_id: Uuid }>('/security/registered-vehicles', {
      method: 'POST',
      body: JSON.stringify(body),
    });
  }
  };
}
